import { useEffect } from 'react';
import { useCookies } from 'react-cookie'; // Assuming you're using react-cookie

const isCrawler = () => {
  return (
    navigator.userAgent.includes('Googlebot') ||
    navigator.userAgent.includes('Bingbot')
  );
};

const RedirectComponent = () => {
  const [cookies] = useCookies(['token']);

  useEffect(() => {
    const token = cookies.token;
    const handleRedirect = async () => {
      if (!isCrawler()) {
        await new Promise((resolve) => setTimeout(resolve, 2000));
        if (token) {
          window.location.href = `https://TheUncensored.AI/app?userToken=${token}`;
        } else {
          window.location.href = 'https://TheUncensored.AI';
        }
      }
    };
    handleRedirect();
  }, [cookies.token]);

  return <div>The site has moved to a new domain, redirecting... ❤️</div>;
};

export default RedirectComponent;
